import { TOC_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/node-view-renderers.js";
const pluginToc = (config = {}) => {
  return {
    config,
    type: TOC_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginToc
};
//# sourceMappingURL=viewer.js.map
